import React from 'react';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import VoyagerEnhancedSearchView from './VoyagerEnhancedSearch';
import VoyagerEnhancedSearchSchema from './VoyagerEnhancedSearchSchema';

type VoyagerEnhancedSearchEditProps = React.ComponentProps<
  typeof VoyagerEnhancedSearchView
> & {
  block: string;
  selected?: boolean;
  onChangeBlock: (block: string, data: Record<string, unknown>) => void;
};

const VoyagerEnhancedSearchEdit: React.FC<VoyagerEnhancedSearchEditProps> = (
  props,
) => {
  const { data, block, onChangeBlock, selected } = props;

  const triggerRateLimitTest = (scenario: 'system' | 'session') => {
    onChangeBlock(block, {
      ...(data || {}),
      testRateLimitScenario: scenario,
      testRateLimitNonce: Date.now(),
    });
  };

  return (
    <>
      <VoyagerEnhancedSearchView {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={VoyagerEnhancedSearchSchema}
          title={VoyagerEnhancedSearchSchema.title}
          onChangeField={(id: string, value: unknown) => {
            onChangeBlock(block, {
              ...(data || {}),
              [id]: value,
            });
          }}
          formData={data}
          block={block}
        />
        <div className="field ves-rate-limit-test-panel">
          <div className="wrapper">
            <div className="field-label">429 Test Tools</div>
            <p className="help">
              Use these buttons to preview the frontend states without waiting
              for the backend to return a real rate-limit response.
            </p>
            <div className="ves-rate-limit-test-actions">
              <button
                type="button"
                className="ui button"
                onClick={() => triggerRateLimitTest('system')}
              >
                Test Daily Limit
              </button>
              <button
                type="button"
                className="ui button"
                onClick={() => triggerRateLimitTest('session')}
              >
                Test Session Limit
              </button>
            </div>
          </div>
        </div>
      </SidebarPortal>
    </>
  );
};

export default VoyagerEnhancedSearchEdit;
